import { jsx as _jsx } from "react/jsx-runtime";
const IconButton = ({ children, onClick, disabled, className = '' }) => {
    return (_jsx("button", { className: `sudoku-controls__icon-button ${className}`, onClick: onClick, disabled: disabled, children: children }));
};
export default IconButton;
